import DataIcon from "assets/images/defaultIcons/data.svg";
import theme from "assets/theme";
import React, { useContext, useMemo } from "react";
import { Image, StyleSheet, Text, View } from "react-native";
import { appIconSize } from "web/constants";
import PressableContainer from "webComponentsFormElements/PressableContainer.component";
import { OrganizationContext } from "webContext/Organization.context";

const classes = StyleSheet.create({
  previewContainer: {
    gap: 5,
    alignItems: "center",
  },
  image: {
    width: appIconSize * 0.9,
    height: appIconSize * 0.9,
  },
  infoContainer: {
    gap: 8,
    alignItems: "center",
    flex: 1,
  },
  createdAtText: {
    fontSize: theme.font.size.small,
    color: theme.color.darkGrey,
    fontStyle: "italic",
  },
  contactsLabel: {
    fontSize: theme.font.size.small,
    fontWeight: theme.font.weight.medium,
    color: theme.color.darkGrey,
  },
  contactText: {
    fontSize: theme.font.size.small,
    color: theme.color.darkGrey,
  },
  contactsSection: {
    alignItems: "center",
    gap: 2,
  },
});

export default function PlatformCard(props) {
  const { platform, onPlatformEdit } = props;

  const { organizationColor } = useContext(OrganizationContext);

  const stateClasses = useMemo(
    () =>
      StyleSheet.create({
        root: {
          backgroundColor: theme.color.background,
          borderWidth: 2,
          borderColor: organizationColor,
          boxShadow: "0px 2px 3px rgba(0, 0, 0, 0.25)",
          borderRadius: 15,
          padding: 15,
          flexDirection: "row",
          alignItems: "center",
          gap: 40,
        },
        title: {
          color: organizationColor,
          fontWeight: theme.font.weight.semibold,
          fontSize: theme.font.size.body,
          textAlign: "center",
        },
        statusText: {
          marginTop: 5,
          fontSize: theme.font.size.body,
          fontWeight: theme.font.weight.semibold,
          color: platform.isOnline ? theme.color.green : theme.color.red,
        },
        icon: {
          height: appIconSize * 0.9,
          width: appIconSize * 0.9,
          fill: organizationColor,
        },
      }),
    [organizationColor, platform.isOnline],
  );

  return (
    <PressableContainer
      style={stateClasses.root}
      onPress={() => onPlatformEdit(platform)}
    >
      <View style={classes.previewContainer}>
        <Text style={stateClasses.title}>{platform.title}</Text>
        {platform.signedFileUrl ? (
          <Image
            source={{ uri: platform.signedFileUrl }}
            resizeMode="contain"
            style={classes.image}
          />
        ) : (
          <DataIcon style={stateClasses.icon} />
        )}
        <Text style={stateClasses.statusText}>
          {platform.isOnline ? "Online" : "Offline"}
        </Text>
      </View>
      <View style={classes.infoContainer}>
        {platform.createdAt && (
          <Text style={classes.createdAtText}>
            Created: {new Date(platform.createdAt).toLocaleDateString()}
          </Text>
        )}
        {platform._associations?.otherContacts?.length > 0 && (
          <View style={classes.contactsSection}>
            <Text style={classes.contactsLabel}>Contacts:</Text>
            {platform._associations.otherContacts
              .slice(0, 2)
              .map((contact, __) => (
                <Text key={contact.otherContactId} style={classes.contactText}>
                  {contact.name}
                </Text>
              ))}
            {platform._associations.otherContacts.length > 2 && (
              <Text style={classes.contactText}>
                +{platform._associations.otherContacts.length - 2} more
              </Text>
            )}
          </View>
        )}
      </View>
    </PressableContainer>
  );
}
